/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Switch, { SwitchProps } from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
  Autocomplete,
} from '@mui/material';
import { toast } from 'react-toastify';
import { getActiveSegment, getActiveProducts } from '../../../api/productSamplingMaintenanceAPI';
import useProductSamplingContext from '../context/useProductSamplingContext';

export default function AddProductDetails() {
  const { auth, activeTab, addProductModal, setAddProductModal, handleAddProduct } =
    useContext(useProductSamplingContext);

  const [productOptions, setProductOptions] = useState([]);
  const [segmentOptions, setSegmentOptions] = useState([]);

  const loadProductionOptions = async () => {
    try {
      const response = await getActiveProducts({ keyword: '' });
      const { code, data } = response.data;

      if (code === '200') {
        const newArr = data?.map((row, index) => ({
          id: index,
          product_code: row.product_code,
          product_name: row.product_name,
        }));
        const dropdownValue = newArr?.map((row, index) => ({
          value: row.product_code,
          label: row.product_name,
        }));
        setProductOptions([{ value: null, label: 'Select Product' }, ...dropdownValue]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadSegmentOptions = async () => {
    try {
      const response = await getActiveSegment({});
      const { code, segments } = response.data;

      if (code === '200') {
        setSegmentOptions(segments);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleAddRow = () => {
    setAddProductModal({
      ...addProductModal,
      products: [
        ...addProductModal.products,
        {
          id: addProductModal.products.length + 1,
          product_code: '',
          product_name: '',
          product_selected: { value: null, label: 'Select Product' },
          segments: [],
        },
      ],
    });
  };

  const handleRemoveRow = (row) => {
    const newArr = addProductModal?.products?.filter((item) => row.id !== item.id);

    setAddProductModal({
      ...addProductModal,
      products: newArr,
    });
  };
  const handleOnChangeSwitch = (event) => {
    setAddProductModal({
      ...addProductModal,
      is_published: event.target.checked === true ? 1 : 0,
    });
  };
  const handleChangeProductDropdown = (newValue, row, index) => {
    const newArr = [...addProductModal.products];

    newArr[index] = {
      id: row.id,
      product_code: newValue?.value,
      product_name: newValue?.label,
      product_selected: newValue,
      segments: newArr[index]?.segments,
    };

    setAddProductModal({ ...addProductModal, products: newArr });
  };
  const handleChangeVisibleTo = (event, item, rowIndex, segmentIndex) => {
    const newArr = [...addProductModal.products];

    const isCheck = event.target.checked === true ? 1 : 0;
    if (newArr[rowIndex].segments.length > 1) {
      newArr[rowIndex].segments[segmentIndex] = {
        segment_id: item.segment_id,
        is_visible: isCheck,
      };
    } else {
      const addSegment = segmentOptions.map((row) => ({
        segment_id: row.segment_id,
        is_visible: row.segment_id === item.segment_id ? isCheck : 0,
      }));

      newArr[rowIndex].segments.push(...addSegment);
    }

    setAddProductModal({ ...addProductModal, products: newArr });
  };

  const columns = [
    {
      field: 'product_selected',
      headerName: 'Product Name',
      width: 380,
      renderCell: (params) => (
        <div>
          <Autocomplete
            disablePortal
            id='product_selected'
            disableClearable
            options={productOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(param) => <TextField {...param} label='Product' />}
            size='small'
            value={params?.row?.product_selected}
            onChange={(e, newValue) =>
              handleChangeProductDropdown(
                newValue,
                params.row,
                params.api.getRowIndex(params.row.id),
              )
            }
            sx={{ backgroundColor: '#fff', width: '430%' }}
            required
          />
        </div>
      ),
    },
    {
      field: 'visible_segments',
      headerName: 'Visible to',
      width: 600,
      renderCell: (params) => (
        <Grid container spacing={2}>
          {segmentOptions?.length > 1
            ? segmentOptions.map((item, i) => (
                <Grid item md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={params?.row?.segments[i]?.is_visible === 1}
                        name={item.segment_name}
                        onChange={(event) =>
                          handleChangeVisibleTo(
                            event,
                            item,
                            params.api.getRowIndex(params.row.id),
                            i,
                          )
                        }
                      />
                    }
                    label={item.segment_name}
                  />
                </Grid>
              ))
            : ''}
        </Grid>
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      alignitems: 'center',
      renderCell: ({ row }) => (
        <div>
          <Button
            size='small'
            variant='contained'
            color='error'
            startIcon={<CloseIcon />}
            onClick={() => handleRemoveRow(row)}
          >
            {' '}
            Remove
          </Button>
        </div>
      ),
    },
  ];
  const handleClose = () => {
    setAddProductModal({ ...addProductModal, toggle: false, product: {} });
  };

  useEffect(() => {
    loadProductionOptions();
    loadSegmentOptions();
  }, [addProductModal.toggle]);
  return (
    <Dialog onClose={handleClose} open={addProductModal.toggle} fullWidth maxWidth='lg'>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Add Product Details
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid xs={6} sm={6} md={6} sx={{ fontWeight: 'bold' }}>
            <Switch
              checked={addProductModal?.is_published === 1}
              color='success'
              size='lg'
              onChange={(event) => handleOnChangeSwitch(event)}
            />{' '}
            Publish Product
          </Grid>
          <Grid xs={6} sm={6} md={6}>
            <Button
              size='small'
              variant='contained'
              color='success'
              sx={{ float: 'right' }}
              onClick={(e) => handleAddRow()}
              startIcon={<AddOutlinedIcon />}
            >
              Add New Row(s)
            </Button>
          </Grid>
        </Grid>

        <Grid xs={12} sm={12} md={12}>
          <div className='table-container' style={{ height: '500px', marginTop: '20px' }}>
            <DataGridPro
              rows={addProductModal?.products}
              columns={columns}
              getRowHeight={() => 'auto'}
              sx={{
                '& .MuiDataGrid-cell': {
                  padding: 0,
                },
              }}
            />
          </div>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='success' onClick={handleAddProduct}>
          Submit
        </Button>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
